var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRightColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.045 12.8682C10.1204 12.9461 10.219 12.9941 10.3291 12.9941C10.5552 12.9941 10.7292 12.8142 10.7292 12.5802C10.7292 12.4662 10.6886 12.3583 10.619 12.2863L6.25907 7.99115L10.619 3.708C10.6886 3.63001 10.7292 3.51604 10.7292 3.40806C10.7292 3.17411 10.5552 2.99414 10.3291 2.99414C10.219 2.99414 10.1262 3.04214 10.045 3.12012L5.41838 7.6672C5.33142 7.75719 5.27344 7.87117 5.27344 7.99714C5.27344 8.12312 5.32561 8.2251 5.41838 8.32108L10.045 12.8682Z",
    fill: "white",
    stroke: "#1080FF",
    strokeWidth: 0.96639
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightColor);
export default __webpack_public_path__ + "static/media/chevron_right_color.dd67ecd639459ce7b1215fdc412a9ddc.svg";
export { ForwardRef as ReactComponent };